import InAppMessage from "./in-app-message.js";
import { DOMUtils as ue } from "../../util/dom-utils.js";
export default class SlideUpMessage extends InAppMessage {
  constructor(e, t, s, o, i, r, n, d, a, u, p, m, c, l, v, x, f, h, g, I, M) {
    (x = x || InAppMessage.th.Mh),
      (v = v || InAppMessage.th.Dh),
      super(
        e,
        (t = t || InAppMessage.TextAlignment.START),
        s,
        o,
        i,
        r,
        n,
        d,
        a,
        u,
        p,
        m,
        void 0,
        c,
        l,
        v,
        x,
        f,
        h,
        g,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        I,
        M,
      ),
      (this.Te = InAppMessage.TextAlignment.START);
  }
  xe() {
    return !1;
  }
  Ge() {
    const e = document.createElement("span");
    return e.appendChild(document.createTextNode(this.message || "")), e;
  }
  Ah(e) {
    const t = e.getElementsByClassName("ab-in-app-message")[0];
    ue.no(t, !0, !0) ||
      (this.slideFrom === InAppMessage.SlideFrom.TOP
        ? (t.style.top = "0px")
        : (t.style.bottom = "0px")),
      super.Ah(e);
  }
  ss() {
    return super.ss(SlideUpMessage.es);
  }
  static an(e) {
    return new SlideUpMessage(
      e[InAppMessage.hs.ea],
      e[InAppMessage.hs.ra],
      e[InAppMessage.hs.Sh],
      e[InAppMessage.hs.xs],
      e[InAppMessage.hs.sa],
      e[InAppMessage.hs.ta],
      e[InAppMessage.hs.URI],
      e[InAppMessage.hs.ia],
      e[InAppMessage.hs.oa],
      e[InAppMessage.hs.pa],
      e[InAppMessage.hs.ma],
      e[InAppMessage.hs.os],
      e[InAppMessage.hs.ua],
      e[InAppMessage.hs.ca],
      e[InAppMessage.hs.fa],
      e[InAppMessage.hs.da],
      e[InAppMessage.hs.la],
      e[InAppMessage.hs.ga],
      e[InAppMessage.hs.ja],
      e[InAppMessage.hs.ba],
      e[InAppMessage.hs.CSS],
    );
  }
}
SlideUpMessage.es = InAppMessage.qe.pn;
